// @ts-nocheck
import React, { useState } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import { toast } from 'react-toastify';
import SkuForm from '../components/SkuForm';
import { useForm } from 'react-hook-form';import TerritoryRestrictions from '../../settings/territory/components/TerritoryRestrictions';
import WorkflowRestrictions from '../../settings/workflow/components/WorkflowRestrictions';
import { useTranslation } from 'react-i18next';
import Button from '../../common/Button';
export default function AddSku({
  done,
  cancel,
  addMode,
  platforms,
  packageTypes,
  gameId,
  saveSku,
  columnCssClass,
  currentUser,
  addTerritories,
  territories,
  addWorkflows,
  workflows,
  keyProviders = [],
}) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
  } = useForm();
  const defaultDisabledKeyWorkflows = workflows.filter(
    (x) => x.defaultDisallowed
  );

  const onSubmit = async (data) => {
    data.disallowListedKeyWorkflows =
      data.disallowListedKeyWorkflows !== 'Allow Only';
    data.disallowListedTerritories =
      data.disallowListedTerritories !== 'Allow Only';
    const workflowIds = data.workflows?.map((x) => x.id);
    const territoryIds = data.territories?.map((x) => x.id);
    try {
      const addedSKU = await saveSku(gameId, { ...sku, ...data });
      let promises = [];
      if (territoryIds?.length > 0) {
        promises.push(
          Promise.resolve(addTerritories(addedSKU.skuId, gameId, territoryIds))
        );
      }
      if (workflowIds?.length > 0) {
        promises.push(
          Promise.resolve(addWorkflows(addedSKU.skuId, gameId, workflowIds))
        );
      }
      Promise.all(promises).then(() => {
        toast.success(t('Sku saved'));
        done(sku);
      });
    } catch (e) {
      toast.error(e.message ?? t('Failed to save sku'));
    }
  };

  const [sku] = useState({
    id: '',
    name: '',
    appId: '',
    validCodeFormatMasks: '',
    notesHTML: '',
    licenseExpires: '',
    isLicenseExpired: true,
    isArchived: false,
    skuKeyCodeMetrics: null,
    skuKeyRequestStats: {
      authorisedRequests: 0,
      declinedRequests: 0,
      openRequests: 0,
      keysRequested: 0,
    },
    skuSKUs: [],
  });

  return (
    <SlideoutLayout
      title={t('Add sku')}
      cancel={cancel}
      done={done}
      bar={
        <Button
          text={t('Save')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
          testId="save-sku-button"
        />
      }
    >
      <SkuForm
        sku={sku}
        register={register}
        errors={errors}
        control={control}
        addMode={addMode}
        columnCssClass={columnCssClass}
        platforms={platforms}
        keyProviders={keyProviders}
        packageTypes={packageTypes}
        currentUser={currentUser}
      />
      <TerritoryRestrictions
        register={register}
        setValue={setValue}
        territories={territories}
      />

      <WorkflowRestrictions
        register={register}
        setValue={setValue}
        workflows={workflows}
        restricted={defaultDisabledKeyWorkflows.length > 0}
        restrictions={defaultDisabledKeyWorkflows}
      />
    </SlideoutLayout>
  );
}


